<template>
  <div id="imageTallor">
    <div class="imgClass">
      <div style="position: relative">
        <div id="moveId" @touchmove="vtouchmove()" @touchstart="vtouchstart()"
             @touchend="vtouchend()" v-show="saveButtonShow"
             style="border: 1px solid #4fb8e3;position: absolute;left: 0;top: 0;z-index: 1000">
          <div id="right-down" class="right-down"></div>
        </div>

        <img name="userimg" id="userimg" :src="getImg()"/>
        <!--<canvas id="c3"></canvas>-->
      </div>

      <mt-button v-show="!saveButtonShow" @click="uploadImage" class="mtButton" type="default">上传图片</mt-button>
      <mt-button v-show="saveButtonShow" @click="saveImage" class="mtButton" type="default">保存图片</mt-button>
      <mt-button v-show="saveButtonShow" @click="cancleImg" class="mtButton" type="default">取消</mt-button>
      <mt-button @click="goback" class="mtButton" type="default">返回</mt-button>
    </div>
    <input name="uploadFile" style="display: none" id="uploadFile" type="file" @change="onFileChange"/>
  </div>
</template>
<script>
  import {Button,Toast} from 'mint-ui';
  var startx;
  var starty;
  var startLeft;
  var startTop;
  var isDown = false;
  var photoFile;
  export default {
    name: 'imageTallor',
    data () {
      return {
        cur: {
          x: 0,
          y: 0
        },
        dx: 0, dy: 0, x: 0, y: 0, boxX: 0, boxY: 0,
        flag: false,
        imgWH: 200,
        saveButtonShow: false,
        url: "0"
      }
    },

    methods: {
      cancleImg:function () {
       window.location.reload();
      },
      goback:function () {
        history.go(-1); //后退1页
      },
      saveImage: function () {
        var width = userimg.width;
        var height = userimg.height;
        var moveIdDiv = document.getElementById("moveId");

        var _photoadd_url = domain("_photoadd");
        var that = this;
        var formData = new FormData();
        formData.append("myphotofile",photoFile);
        formData.append("subimagex",moveId.offsetLeft);
        formData.append("subimagey",moveId.offsetTop);
        formData.append("subimageh", moveId.style.height.split(".")[0]);
        formData.append("subimagew", moveId.style.width.split(".")[0]);
        formData.append("changex",width);
        formData.append("changey",height);
        that.$http.post(
          _photoadd_url,
          formData,
          {emulateJSON: true,
            headers:{
              "Content-Type": "multipart/form-data"
            }}
          )
          .then(function (response) {  //接口返回数据
            var code = response.data.code;
            //跳转到合同签署页面
            if(code == '0'){
              this.$router.push({
                path: '/main',
                name: 'main'
              })
            }else {
              var msg = response.data.msg;
              this.$toast(msg);
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      down: function () {
        var moveId = document.getElementById("moveId");
        var userimg = document.getElementById("userimg");
        this.flag = true;
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.cur = {x: touch.clientX, y: touch.clientY};
        this.dx = moveId.offsetLeft;
        this.dy = moveId.offsetTop;
        this.boxX = userimg.offsetLeft + userimg.clientWidth - moveId.clientWidth;
        this.boxY = userimg.offsetTop + userimg.clientHeight - moveId.clientHeight;
      },
      move: function () {
        var moveId = document.getElementById("moveId");
        var userimg = document.getElementById("userimg");
        if (this.flag) {
          var touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }
          this.x = this.dx + touch.clientX - this.cur.x;
          this.y = this.dy + touch.clientY - this.cur.y;
          moveId.style.left = this.x + "px";
          moveId.style.top = this.y + "px";
          if (moveId.offsetLeft < userimg.offsetLeft) {
            moveId.style.left = userimg.offsetLeft;
          } else if ((moveId.offsetLeft + this.imgWH) > (userimg.offsetLeft + userimg.width)) {
            moveId.style.left = userimg.offsetLeft + userimg.width - this.imgWH + "px";
          }
          if (moveId.offsetTop < userimg.offsetTop) {
            moveId.style.top = userimg.offsetTop;
          } else if ((moveId.offsetTop + this.imgWH) > (userimg.offsetTop + userimg.height)) {
            moveId.style.top = userimg.offsetTop + userimg.height - this.imgWH + "px";
          }
        }
      },
      end: function () {
        this.flag = false;
      },
      vtouchmove: function (e) {
        event.preventDefault();
        this.move();
      },
      vtouchstart: function (e) {
        event.preventDefault();
        this.down();
      },
      vtouchend: function (e) {
        event.preventDefault();
        this.end();
      },
      uploadImage: function () {
        uploadFile.click();
      },
      onFileChange(e) {
        var files = document.getElementById("uploadFile").files;
        photoFile = files[0];
        userimg.src = window.URL.createObjectURL(files[0]);
        this.saveButtonShow = true;
        var moveId = document.getElementById("moveId");
        var userImgWidth = userimg.naturalWidth;
        var width = userimg.width;
        var width = (userImgWidth/width)*200;
        this.imgWH = width;
        console.log(width);
        moveId.style.width = width+"px";
        moveId.style.height = width+"px";

      },
      getParams(){
        let params = this.$route.query;
        var photoId = params.photoId;
        if (photoId != 0) {
          this.url = domain("_imgView") + photoId;
        } else {
          this.url = "/static/img/contract/user1.png";
        }
      },
      getImg: function () {
        return this.url;
      }
    },
    components: {},
    mounted: function () {
      this.getParams();
    }
  }

</script>
<style>
  #imageTallor {
    background-color: #000000;
    width: 100%;
    height: 100%;

  }

  .imgClass {
    text-align: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    /*margin: auto;*/
    /*min-width: 400px;*/
    /*min-height: 200px;*/
    /*max-height: 80%;*/
    /*max-width: 80%;*/
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 2rem;
  }

  .imgClass img {
    width: 100%;
    height: auto
  }

  .imgClass canvas {
    max-height: 100%;
    max-width: 100%;
  }

  .mtButton {
    margin-top: 1rem;
  }

  .right-down {
    width: 10px;
    height: 10px;
    background: #00b9ed;
    font-size: 0;
    position: absolute;
    bottom: -4px;
    right: -4px;
    cursor: se-resize;;
    z-index: 10000
  }
</style>



// WEBPACK FOOTER //
// src/module/my/ImageTailor.vue